export default {"src":"/customer-services/_next/static/media/dryer.795fd52b.svg","height":36,"width":31,"blurWidth":0,"blurHeight":0};